
const TentangComponentOpenData = () =>{
    return(
        <section id="tentang" >
            <div className="container">
                <div className="row content">
                    <div className="col-md-5 order-1 order-md-2" data-aos="fade-left">
                        <img src={`${process.env.PUBLIC_URL}/template/img/features.svg`} className="img-fluid" alt="" />
                    </div>
                    <div className="col-md-7 pt-5 order-2 order-md-1" data-aos="fade-up">
                        <h2 className="flex-content"><b> Tentang Sampang Satu Data </b></h2>
                        <br/>
                        <p className="font-size-medium">
                            Satu Data adalah kebijakan tata kelola data pemerintah yang bertujuan untuk menciptakan data berkualitas, mudah diakses, dan dapat dibagipakaikan antar instansi pusat serta daerah. Kebijakan ini secara Nasional tertuang dalam Peraturan Presiden Nomor 39 Tahun 2019 Tentang Satu Data Indonesia.
                        </p>
                        <p className="font-size-medium">
                            Implementasi Sampang Satu Data diatur dalam Peraturan Wali Kabupaten Sampang Nomor 126 Tahun 2021 Tentang Satu Data Indonesia Tingkat Kabupaten Sampang. Melalui Satu Data, pemerintah Kabupaten Sampang berupaya untuk membangun tata kelola data yang baik demi terwujudnya transparansi dan akuntabilitas pemerintahan, serta mendukung pembangunan nasional.
                        </p>
                        <p className="font-size-medium">
                            Open Data merupakan bagian dari sistem Sampang Satu Data. Open Data menyediakan data tentang Kabupaten Sampang untuk dapat diakses oleh masyarakat secara terbuka. Melalui Open Data, masyarakat dapat mencari, melihat, dan mengunduh data yang telah disediakan.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TentangComponentOpenData;